import objectParsers from "../../utils/objectParsers";
import { TableHeaderCategoryConfig } from "./tableContext/TableContext";

export const tableLocalGlobalSearch = (
  tableValues?: number[] | string[],
  tableSearch?: number | string,
  showItemsWhenEmpty = true,
) => {
  if (tableValues && tableSearch) {
    return tableValues?.some((tableValue) => {
      return tableValue
        ?.toString()
        .toLowerCase()
        .includes(tableSearch.toString().toLowerCase());
    });
  }
  return showItemsWhenEmpty;
};

export const tableLocalCategorySearch = (
  tableData?: any[],
  tableSearch?: object,
  showItemsWhenEmpty = true,
) => {
  if (tableData && tableSearch) {
    const tableDataKeys = objectParsers.getKeys(tableData[0]);

    const tableSearchToArray = objectParsers
      .transformObjectToArray(tableSearch)
      .filter((item) => item.value && tableDataKeys.includes(item?.key));

    const filteredTableData = tableData.filter((tableItem) => {
      return tableSearchToArray.every((tableSearchItem) => {
        const tableObjectValue = tableItem[tableSearchItem?.key] ?? "";
        if (Array.isArray(tableObjectValue) && tableObjectValue.length) {
          const objectKey = Object.keys(tableObjectValue[0])[0];
          const objectValues = tableObjectValue.map((item) => item[objectKey]);

          return objectValues.some((value) =>
            value
              ?.toString()
              .toLowerCase()
              .includes(tableSearchItem?.value?.toString().toLowerCase()),
          );
        }

        if (!tableObjectValue) {
          return false;
        }

        return tableObjectValue
          ?.toString()
          .toLowerCase()
          .includes(tableSearchItem.value.toString().toLowerCase());
      });
    });

    return filteredTableData;
  }
  if (showItemsWhenEmpty) {
    return tableData ?? [];
  }
  return [];
};

export const getFilteredTableHeader = (
  selectedRolesString: string | undefined,
  allHeader: TableHeaderCategoryConfig[],
  permanentKeys: string[],
): TableHeaderCategoryConfig[] => {
  if (!selectedRolesString) return allHeader;

  let selectedRoles: unknown;
  try {
    selectedRoles = JSON.parse(selectedRolesString);
  } catch {
    return allHeader;
  }
  if (!Array.isArray(selectedRoles) || selectedRoles.length === 0) {
    return allHeader;
  }
  const selectedRoleIds = selectedRoles
    .map((role) => (typeof role === "string" ? role : role?.id))
    .filter((id): id is string => typeof id === "string");

  const allowedValues = new Set([...permanentKeys, ...selectedRoleIds]);

  const filteredHeader = allHeader.filter((header) =>
    allowedValues.has(header.value),
  );

  return filteredHeader;
};

interface TableItemData {
  id: string | number;
  data: any[];
}

export const filterTableDataByHeader = (
  initialTableData: TableItemData[],
  selectedRolesString: string | undefined,
  allHeader: TableHeaderCategoryConfig[],
  permanentKeys: string[],
): TableItemData[] => {
  const filteredHeader = getFilteredTableHeader(
    selectedRolesString,
    allHeader,
    permanentKeys,
  );
  const allowedValues = filteredHeader.map((header) => header.value);

  const allHeaderMap: { [key: string]: number } = {};
  allHeader.forEach((header, index) => {
    allHeaderMap[header.value] = index;
  });

  const filteredTableData = initialTableData.map((item) => {
    const newRowData: any[] = [];

    allowedValues.forEach((key) => {
      const originalIndex = allHeaderMap[key];
      newRowData.push(item.data[originalIndex]);
    });

    return {
      ...item,
      data: newRowData,
    };
  });

  return filteredTableData;
};
